import React, { useRef, useState } from "react";
import { MenuBoardTabMenu } from "../../styled/setting";
import { productQuantityState } from "../../function/store";

const Products = ({ menuGroups }) => {
  const scrollRef = useRef(null);
  const groupRefs = useRef([]);

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = x - startX;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
  };

  const scrollToGroup = (index) => {
    if (isDragging) return;

    const target = groupRefs.current[index];
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const visibleGroups = menuGroups?.filter((group) =>
    group.products?.some((item) => item.status !== "PAUSE" && item.useDisplay),
  );

  return (
    <>
      <MenuBoardTabMenu className="tabs">
        <li className="active">메뉴</li>
      </MenuBoardTabMenu>
      {visibleGroups && visibleGroups.length > 0 && (
        <div
          className="category"
          ref={scrollRef}
          onMouseDown={handleMouseDown}
          onMouseMove={handleMouseMove}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseLeave}>
          <ul>
            {visibleGroups.map((group, index) => (
              <li onClick={() => scrollToGroup(index)}>{group.name}</li>
            ))}
          </ul>
        </div>
      )}
      <ul className="menuGroup">
        {visibleGroups.map((group, index) => (
          <li key={`menu-${group.id}`} ref={(el) => (groupRefs.current[index] = el)}>
            <p>{group.name}</p>
            <ul className="products">
              {group.products
                .filter((item) => item.status !== "PAUSE" && item.useDisplay)
                .map((item) => {
                  const stockInfo = productQuantityState(item);

                  return (
                    <li key={item.id} className={stockInfo?.status}>
                      <img
                        src={imgHandler(item.media)}
                        alt={item.name}
                        onError={(e) => (e.target.src = "/img/icon_function_4.png")}
                      />
                      <div className="productInfo">
                        {stockInfo && <span className={`status`}>{stockInfo.message}</span>}
                        <span className="name">{item.name}</span>
                        <span className="shortDescription">{item.shortDescription}</span>
                        <span className="price">{formatNumber(item?.price)}원</span>
                      </div>
                    </li>
                  );
                })}
            </ul>
          </li>
        ))}
      </ul>
    </>
  );
};

export default Products;
